


import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Components
import LoaderComponent from "@/shared/components/Loader.vue";
import ErrorMessagesComponent from "@/shared/components/ErrorMessages.vue";
import SuccessMessageComponent from "@/shared/components/SuccessMessage.vue";

import EditButton from "../buttons/EditButton.vue";
import Field from "../fields/Field.vue";
import PrivacyEdit from "../privacy/PrivacyEdit.vue";

// Services
import UserPrivacyService from "../../services/user-privacy-service";
import HttpService from "@/shared/services/http-service";

@Component({
  components: {
    LoaderComponent,
    ErrorMessagesComponent,
    SuccessMessageComponent,
    EditButton,
    Field,
    PrivacyEdit
  },
  computed: {
    ...mapGetters([
      "config",
      "sectionLoading",
      "sectionFormOpen",
      "sectionError",
      "sectionSuccess",
      "privacyData",
      "formData",
      "formSection"
    ]),
  }
})
export default class FormComponent extends Vue {
  public saveButtonActive(type: string): boolean {
    if (type === "privacy") {
      return this.$store.getters.privacyDataModified;
    }
    return true;
  }

  public saveSection(type: string): void {
    this.$store.commit("setFormSectionError", { type: type, status: false });
    this.$store.commit("setFormSectionSubmitted", { type: type, status: true });
    this.$store.commit("setFormSectionFieldErrors", { type: type, errors: [] });
    this.loadingUpdate(type, true);
    this.sendUpdateData(type);
  }

  public successUpdate(type: string): void {
    this.$store.commit("setFormSectionOpen", { type: type, status: false });
    this.$store.commit("setFormSectionSuccess", { type: type, status: true });
  }

  public errorUpdate(type: string, errorMessage: any): void {
    this.$store.commit("setFormSectionError", { type: type, status: true });
    console.error("Error message:", errorMessage);
  }

  public loadingUpdate(type: string, status: boolean): void {
    this.$store.commit("setFormSectionLoading", { type: type, status: status });
  }

  public sendUpdateData(type: string): void {
    if (type === "privacy") {
      UserPrivacyService.updateUserPrivacy(
        this.$store.getters.formData.privacyData,
        HttpService
      )
        .then(() => {
          this.successUpdate(type),
          this.$emit("submit");
        })
        .catch((error) => this.errorUpdate(type, error))
        .finally(() => this.loadingUpdate(type, false));
    }
  }
}
